export default {
  namespaced: true,
  state: {
    mounted: false,
  },
  mutations: {
    SET_MOUNTED(state, data) {
      state.mounted = data
    }
  },
  actions: {
    setMounted({ commit }, data) {
      commit('SET_MOUNTED', data)
    }
  },
}